<template>
  <div class="chat-detail"   v-loading="loading">
    <div class="detail-top mb-10">
      <img class="avatar mr-15" :src="currentLogo || require('@/assets/image/avator/LOGO.png')" alt="">
      <div class="name">{{currentName}}</div>
    </div>
    <div class="detail-body" id="scroll-body">
      <div v-for="(item,index) in currentMessage" class="m-15" :key="index">
        <div class="mb-25 time" v-if="isDisplayTime(index)">{{formatDate(item.createTime)}}</div>
        <div class="user-message flex-center-center mb-20" v-if="isUser(item.sendUserId)">
          <img class="avatar mr-15" :src="currentLogo || require('@/assets/image/avator/LOGO.png')" alt="个人头像">
          <!-- type 0消息 1图片 2商品 3订单 前端判断 -->
          <!-- 消息 -->
          <div v-if="item.type===0" class="message-content">{{item.msg}}</div>
          <!-- 图片 -->
          <el-image
            v-else-if="item.type===1"
            class="message-image"
            :src="item.msg"
            :preview-src-list="[item.msg]">
          </el-image>
          <!-- 商品 -->
          <chat-good v-else-if="item.type===2" :data="JSON.parse(item.msg)"></chat-good>
          <!-- 订单 -->
          <chat-order v-else-if="item.type===3" :data="JSON.parse(item.msg)"></chat-order>
        </div>
        <div class="shop-message flex-center-center mb-20" v-else>
          <div v-if="item.type===0" class="message-content-shop ml-15">{{item.msg}}</div>
          <!-- 图片 -->
          <el-image
            v-else-if="item.type===1"
            class="message-image"
            :src="item.msg"
            :preview-src-list="[item.msg]">
          </el-image>
          <!-- 商品 -->
          <chat-good v-else-if="item.type===2" :data="JSON.parse(item.msg)"></chat-good>
          <!-- 订单 -->
          <chat-order v-else-if="item.type===3" :data="JSON.parse(item.msg)"></chat-order>
          <img class="avatar  ml-15" :src="shopInfo.logo || require('@/assets/image/avator/LOGO.png')" alt="个人头像">
        </div>
        <div style="clear:both;"></div>
      </div>
    </div>
    <div class="detail-bottom">
      <div class="send-top"></div>
      <el-input
        class="send-body"
        type="textarea"
        placeholder="请输入内容"
        :rows="3"
        v-model="msg"
        resize="none"
      />
      <!-- <textarea class="send-body" name="" id="" cols="60" rows="5"></textarea> -->
      <div class="send-bottom">
        <el-button class="ml-auto" type="primary" size="small" round @click="send()">
          发送
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import chatGood from './chatGood.vue'
import chatOrder from './chatOrder.vue'
import { formatDate } from '@/utils';
import { mapActions, mapGetters } from 'vuex';
export default {
  components: {
    chatOrder,
    chatGood
  },
  computed:{
    ...mapGetters(['userInfo','shopInfo','messageList','currentMessage','currentName','currentLogo','currentId',"loading"])
  },
  data(){
    return {
      formatDate,
      msg: ''
    }
  },
  mounted(){
    this.scrollToBottom()
  },
  watch:{
    currentMessage(){
      this.$nextTick(()=>{this.scrollToBottom()})
    }
  },
  methods:{
    ...mapActions(['getCUserInfo','webSocketSend', 'updateCurrentInfo','getMessageList','loadingClose']),
    isUser(id){
      return id === this.currentId
    },
    send(){
      // type 0消息 1图片 2商品 3订单 前端判断
      if(!this.msg){
        return
      }
      this.webSocketSend({msg:this.msg,type:0})
      this.msg = ""
    },
    isDisplayTime(index){
      // 第一条 index为0 直接展示
      if(!index){
        return true
      }
      let currentTime = new Date(this.currentMessage[index].createTime)
      let lastMessageTime = new Date(this.currentMessage[index-1].createTime)
      // 时间间隔5min
      const interval = 5*60*1000
      return currentTime.valueOf()-lastMessageTime.valueOf()>=interval
    },
    // 滑动到底部
    scrollToBottom(){
      let div = document.getElementById('scroll-body');
      div.scrollTop = div.scrollHeight-div.clientHeight;
      this.loadingClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-detail{
  height: 100%;
  width:50vw;
  .detail-top{
    height: 110px;
    padding: 25px 15px;
    box-sizing: border-box;
    border-bottom: 2px solid #EDEDED;
  }
  .avatar{
    display: inline-block;
    border-radius: 50%;
    width: 60px;
    height: 60px;
  }
  .name{
    display: inline-block;
    font-size: 20px;
    line-height: 60px;
    vertical-align: bottom;
  }
  .detail-body{
    height: calc(100% - 320px);
    overflow-y: auto;
    .time {
      text-align: center;
      color:#A5A5A5;
      font-size: 16px;
    }
    .user-message{
      float: left;
      overflow:hidden;
    }
    .shop-message{
      float: right;
      overflow: hidden;
    }
    .message-content-shop{
      color: white;
      background: #EF4B48;
      padding: 15px 20px;
      border-radius: 8px;
    }
    .message-content{
      background: white;
      padding: 15px 20px;
      border-radius: 8px;
    }
    .message-image{
      height: 200px;
      width: 200px;
    }
  }
  .detail-bottom{
    .send-top{
      height: 60px;
    }
    .send-body{
      height: 93px;
      width: 100%;
    }
    
    .send-bottom{
      margin-top:5px;
      // margin-bottom:27px;
      margin-right: 30px;
      float: right;
    }
  }
}
</style>